import { FC } from 'react'
import {
    Container,
    Content,
    Headline,
    Subheadline,
    TopText,
    ActionsWrapper,
    Footer,
    PlayButtonWrapper,
} from './ScheduleCall.styles'
import Typography from '@/ui/components/typography'

import { ActionButton } from '@/ui/components/buttons/action'
import { MdrModule } from '@/core/modules/mdr/mdr.module'
import { AccountModule } from '@/core/modules/account/account.module'
import { PlayButton } from '@/ui/components/buttons/PlayButton'

export const ScheduleCall: FC = () => {
    const { isMdrActive } = AccountModule.useStore()

    const handleSeeWhy = () => {
        MdrModule.openMdrVideoDialog({
            isMdrActive,
            origin: 'mdr_page',
        })
    }

    const handleScheduleCall = () => {
        MdrModule.openScheduleCallDialog({
            isMdrActive,
            origin: 'mdr_page',
        })
    }

    return (
        <Container>
            <Content>
                <TopText>
                    <Typography variant="l-regular" component="span">
                        Protect your business with confidence.
                    </Typography>
                </TopText>
                <Headline>
                    <Typography variant="xxl-bold" component="h1">
                        At-Bay Stance Managed Detection and Response
                    </Typography>
                </Headline>
                <Subheadline>
                    <Typography variant="l-regular" component="p">
                        Delivers 24/7 expert monitoring to save you time,
                        conserve resources, and provide industry-leading
                        protection.
                    </Typography>
                </Subheadline>
                <Footer>
                    <Typography variant="m-regular" component="p">
                        Connect with our team to get started.
                    </Typography>
                    <ActionsWrapper>
                        <ActionButton
                            onClick={handleScheduleCall}
                            data-testid="schedule-call-button"
                            text="Schedule a Call"
                        />
                        <PlayButtonWrapper>
                            <PlayButton
                                onClick={handleSeeWhy}
                                dataTestId="see-why-button"
                                text="See Why"
                            />
                        </PlayButtonWrapper>
                    </ActionsWrapper>
                </Footer>
            </Content>
        </Container>
    )
}
